module.exports = __webpack_public_path__ + "static/media/Two_Legs_-_With_Support.22cffc05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/position_icons/Two_Legs_-_With_Support.svg
// module id = 765
// module chunks = 0